import ModulePlanningLessonResourceModel from '../../generated/types/model/resource/ModulePlanningLessonResourceModel';

export default class ModulePlanningLessonResourceViewModel extends ModulePlanningLessonResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
